import { callGlobalFunction, readGlobal } from "./utils.js";

export const authFeature = {
  get service() {
    return readGlobal("authService", null);
  },
  loginClient() {
    return callGlobalFunction("performClientLogin");
  },
  loginProvider() {
    return callGlobalFunction("performProviderLogin");
  },
  loginAdmin() {
    return callGlobalFunction("performAdminLogin");
  },
  logoutAdmin() {
    return callGlobalFunction("handleAdminLogout");
  },
  signOut() {
    const authService = readGlobal("authService", null);
    if (!authService || typeof authService.signOut !== "function") {
      throw new Error("Unified auth service is not available.");
    }
    return authService.signOut();
  }
};
